module.exports = __webpack_public_path__ + "static/front/img/instagram2.6b88dd29.jpg";